// 系统语言环境设置 (cn 中文版；en 英文版)
const env = (process.env.PROJECT_ENV || 'xhorse') === 'xhorse' ? 'cn' : 'en'
export default env



// WEBPACK FOOTER //
// ./src/config/dev.js